import { render, staticRenderFns } from "./arboviral_details.vue?vue&type=template&id=3026d6d0&"
import script from "./arboviral_details.vue?vue&type=script&lang=js&"
export * from "./arboviral_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports